import { UserManager, WebStorageStateStore, User } from 'oidc-client'
import store from '@/store/index'

import extendedConfig from '@/tenants.js'
import { BroadcastService, triggerLogoutInAllTabs } from './BroadcastService'

let instance = null
let timeoutRenewToken = null

export default class AuthService {
  userManager = UserManager

  constructor() {
    const AUTH0_DOMAIN = extendedConfig.VUE_APP_CAS_URL
    const settings = {
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      authority: AUTH0_DOMAIN,
      client_id: extendedConfig.VUE_APP_CLIENT_ID,
      client_secret: extendedConfig.VUE_APP_CLIENT_SECRET,
      redirect_uri: extendedConfig.VUE_APP_WEB_URL + '/callback.html',
      response_type: 'code',
      scope: 'openid',
      post_logout_redirect_uri: extendedConfig.VUE_APP_WEB_URL,
      filterProtocolClaims: true,
      state: 'random-state',
      client_authentication: 'client_secret_basic',
      grant_type: 'authorization_code',
      metadata: {
        issuer: extendedConfig.VUE_APP_CAS_URL_SHORT,
        authorization_endpoint: AUTH0_DOMAIN + '/authorize',
        token_endpoint: AUTH0_DOMAIN + '/accessToken',
        userinfo_endpoint: AUTH0_DOMAIN + '/userinfo',
        end_session_endpoint: AUTH0_DOMAIN + '/logout',
        jwks_uri: AUTH0_DOMAIN + '/.well-known/jwks.json',
      },
    }

    this.userManager = new UserManager(settings)

    let that = this
    this.userManager.events.addAccessTokenExpiring(function() {
      that.renewToken()
    })
    this.userManager.events.addSilentRenewError(function() {
      console.log('silent renew error')
    })
  }
  renewToken() {
    console.log('renew token')
    return this.userManager
      .signinSilent()
      .then(() => {
        return this.getAccessToken().then(data => {
          store.commit('userStates/updateToken', data.access_token)
          store.commit('userStates/updateRefreshToken', data.refresh_token)
          return data
        })
      })
      .catch(error => {
        console.log(
          'signinSilent error, clearing and setTimeout for 30 seconds',
        )
        console.error(
          'renewToken (this.userManager.signinSilent) failed with error.',
          error,
        )
        clearTimeout(timeoutRenewToken)
        timeoutRenewToken = setTimeout(() => {
          this.renewToken()
        }, 30000)
      })
  }
  getUser() {
    return this.userManager.getUser()
  }

  login() {
    return this.userManager.signinRedirect()
  }

  logout() {
    triggerLogoutInAllTabs()
    return this.userManager.signoutRedirect({
      extraQueryParams: {
        service: extendedConfig.VUE_TENANT_SERVICE
          ? extendedConfig.VUE_TENANT_SERVICE
          : '',
        client_id: '',
      },
    })
  }
  getAccessToken() {
    return this.userManager
      .getUser()
      .then(data => {
        let checkErrors = {
          noData: !data,
          noAT: !data?.access_token,
          noRT: !data?.refresh_token,
        }
        if (checkErrors.noData || checkErrors.noAT || checkErrors.noRT) {
          console.error(
            `Get access token (this.userManager.getUser) failed. noData: ${
              checkErrors.noData ? 'yes' : 'no'
            }, noAT: ${checkErrors.noAT ? 'yes' : 'no'}, noRT: ${
              checkErrors.noRT ? 'yes' : 'no'
            }.`,
          )
        }
        return {
          access_token: data.access_token,
          refresh_token: data.refresh_token,
        }
      })
      .catch(error => {
        console.error(
          'Get access token (this.userManager.getUser) failed with error.',
          error,
        )
        return false
      })
  }
}

export const authInstance = () => {
  if (!instance) {
    instance = new AuthService()
    // init sync between tabs
    BroadcastService.initialize()
  }

  return instance
}
